import {
  imageSpecFor,
  resolveLayout,
  type BookAttributesV1,
  type SpreadLayoutId,
} from '@kitup/book-schema';
import type { CSSProperties } from 'react';

/**
 * The shape a spread's picture is drawn at, for the box that shows it: the same spec that
 * sizes the image request, so a square book's full spread shows 2:1 and an A5 one 1.41:1.
 */
export function spreadAspect(
  attributes: BookAttributesV1,
  scene: { readonly layoutId: SpreadLayoutId | null; readonly bandImageRatio?: number | null },
): CSSProperties {
  return { aspectRatio: imageSpecFor(resolveLayout(scene, attributes), attributes, scene).aspect };
}

/** A cover is one page, drawn at the page's shape (the server asks for the `split` spec). */
export function coverAspect(attributes: BookAttributesV1): CSSProperties {
  return { aspectRatio: imageSpecFor('split', attributes).aspect };
}
